// @flow
import React, { useState, useEffect } from 'react';
import { withRouter, useLocation } from 'react-router-dom';
// Components
import { SearchBar } from '../../search';
import BottomRow from '../components/BottomRow';
import DownloadApp from '../components/DownloadApp';
import HamburgerMenu from '../components/HamburgerMenu';
import TopRow from '../components/TopRow';
// Styles
import './Header.css';
// Redux
import { connect } from 'react-redux';
// Selectors
import {
  featuresConfigLoadingSelector,
  featuresConfigSelector,
} from '../../preferences/selectors';
import {
  bigClubInformationSelector,
  loggedInSelector,
  loggingInLoadingSelector,
  validatingUserLoadingSelector,
  userIdSelector,
} from '../../user/selectors';
import {
  currentOrderLineItemsSelector,
  ordersListSelector,
} from '../../past-orders/selectors/index';
import {
  copyingOrderLoadingSelector,
  itemsSelector,
} from '../../current-order/selectors/index';
import { themeSelector } from '../../home/selectors';
// Actions
import { getPastOrder } from '../../past-orders/actions/index';
import { copyingOrder } from '../../current-order/actions';
import { fetchTheme } from '../../home/actions';
// Connectors
import currentOrderNumberConnector from '../../current-order/connectors/currentOrderNumberConnector';
// Types
import type { FeaturesConfig } from '../../preferences/types';
import type { Order } from "../../types/Order";
import { currentOrderSelector } from "../../current-order/selectors";

type Props = {
  userId: number,
  featuresConfig: FeaturesConfig,
  loggedIn: boolean,
  loggingInLoading: boolean,
  validatingUserLoading: boolean,
  prevOrderItems: LineItem[],
  currentOrderItems: LineItem[],
  theme: string,
  fetchTheme: () => void,
  order: Order,
};

const Header = (props: Props) => {
  const location = useLocation();

    useEffect(() => {
      props.fetchTheme();
    }, [props.fetchTheme]);

  const [showDownloadApp, setShowDownloadApp] = useState(true);
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);

  return (
    <div>
      <div className="header-wrapper">
        {showDownloadApp && (
          <div className="header-download-app">
            <DownloadApp handleClose={() => setShowDownloadApp(false)} />
          </div>
        )}

        <div className={`header-main theme-${location.pathname === '/' ? props.theme : ''}`}>
          <div
            className={`header-btn-mobile ${
              showHamburgerMenu ? 'header-btn-mobile-active' : ''
            }`}
            onClick={() => setShowHamburgerMenu(!showHamburgerMenu)}
          >
            <div className="header-hamburger-bar1"></div>
            <div className="header-hamburger-bar2"></div>
            <div className="header-hamburger-bar3"></div>
          </div>
          <div className="header-rows">
            <TopRow
              orderNumber={props.orderNumber}
              order={props.order}
              orders={props.orders}
              prevOrderItems={props.prevOrderItems}
              getPastOrder={props.getPastOrder}
              copyingOrder={props.copyingOrder}
              currentOrderNumber={props.currentOrderNumber}
              previousOrderNumber={props.previousOrderNumber}
              copyingOrderLoading={props.copyingOrderLoading}
              currentOrderItems={props.currentOrderItems}
              loggedIn={props.loggedIn}
              loggingInLoading={props.logginInLoading}
              validatingUserLoading={props.validatingUserLoading}
              userId={props.userId}
              bigClubEnabled={props.featuresConfig?.bigclubFeature}
              bigClubInformation={props.bigClubInformation}
              featuresConfigLoading={props.featuresConfigLoading}
            />
            <BottomRow />
          </div>
        </div>
        <div
          className={`header-hamburger-menu 
            ${ showHamburgerMenu ? 'header-hamburger-menu-active' : '' } 
            ${ showDownloadApp ? 'header-hamburger-menu-app-margin' : ''}
          `}
        >
          <HamburgerMenu
            onNavigate={() => setShowHamburgerMenu(false)}
            userId={props.userId}
            bigClubEnabled={props.featuresConfig?.bigclubFeature}
            bigClubInformation={props.bigClubInformation}
          />
        </div>
        <div className="header-search-mobile">
          <SearchBar />
        </div>
      </div>
      <div className={`header-padding ${ showDownloadApp ? 'header-padding-app-margin' : ''}`} />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    userId: userIdSelector(state),
    featuresConfig: featuresConfigSelector(state),
    featuresConfigLoading: featuresConfigLoadingSelector(state),
    order: currentOrderSelector(state),
    prevOrderItems: currentOrderLineItemsSelector(state),
    orders: ordersListSelector(state),
    copyingOrderLoading: copyingOrderLoadingSelector(state),
    currentOrderItems: itemsSelector(state),
    loggedIn: loggedInSelector(state),
    logginInLoading: loggingInLoadingSelector(state),
    validatingUserLoading: validatingUserLoadingSelector(state),
    theme: themeSelector(state),
    bigClubInformation: bigClubInformationSelector(state),
  };
};

const mapDispatchToProps = dispatch => ({
  getPastOrder: orderNumber => dispatch(getPastOrder(orderNumber)),
  copyingOrder: async (currentOrderNumber, previousOrderNumber) =>
    await dispatch(copyingOrder(currentOrderNumber, previousOrderNumber)),
  fetchTheme: () => dispatch(fetchTheme()),
});

export default withRouter(
  currentOrderNumberConnector(
    connect(mapStateToProps, mapDispatchToProps)(Header),
  ),
);
